/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Create pair setting request.
 */
export interface CreatePairSettingRequest {
  pairId: number;
  topOfBookSourceId: number;
}
